import { Http } from "@shared/svelte/Modules/ApiService";
import type { HTTPParams } from "@shared/types/HTTP";
import { PaymentsStore } from "@retailer/stores/PaymentsStore";

const makeReq = async (
  requestData: HTTPParams,
  handleError: Function,
  successCB: (json: any) => void,
) => {
  const errCB = (json: any) => {
    PaymentsStore.set({
      loaded: true,
      failed: true,
      errors: json.errors,
    });
    return handleError();
  };

  await Http(requestData, successCB, errCB);
};

export const schedulePayments = async (
  paymentInstrumentId: number,
  scheduledDate: string,
  invoiceIds: number[],
  handleSuccess: Function,
  handleError: Function,
  creditDistributorIds: number[] = [],
  selectedCredits: { [k: number]: number[] },
) => {
  PaymentsStore.set({
    loaded: false,
    failed: false,
    errors: [],
  });

  const requestData: HTTPParams = {
    method: "POST",
    url: "/api/retailer/invoices/schedule_pay",
    data: {
      payment_instrument_id: paymentInstrumentId,
      scheduled_date: scheduledDate,
      invoice_ids: invoiceIds,
      credit_distributor_ids: creditDistributorIds,
      specified_credits: selectedCredits,
    },
  };

  const successCB = () => {
    PaymentsStore.set({
      loaded: true,
      failed: false,
      errors: [],
    });
    const futureDate = Date.parse(scheduledDate) > Date.now();
    return handleSuccess(futureDate);
  };

  await makeReq(requestData, handleError, successCB);
};

export const cancel = async (
  invoiceIds: number[],
  successCallback: Function,
  errorCallback: Function,
) => {
  const requestData: HTTPParams = {
    method: "POST",
    url: "api/retailer/invoices/cancel_scheduled_pay",
    data: {
      invoice_ids: invoiceIds,
    },
  };
  PaymentsStore.set({ loaded: false, failed: false });
  await Http(requestData, successCallback, errorCallback);
};

export const fetchDistributors = async (
  onSuccess: (data: any[]) => void,
  onError: (error: any) => void,
) => {
  try {
    const requestData = {
      method: "GET",
      url: "/api/retailer/invoices/distributors",
    };

    await Http(requestData, onSuccess, onError);
  } catch (error) {
    onError(error);
  }
};
